import tippy from 'tippy.js/headless';
import domReady from '../helpers/dom-ready';

class Footer {
  static init() {
    return new Footer();
  }

  constructor() {
    this.footer = document.querySelector('.brix-footer');
    this.form = this.footer.querySelector('.newsletter-form');

    this.setupPopperPlugin();
    this.setupLanguageSwitcher();

    this.form.addEventListener('submit', (e) => {
      e.preventDefault();

      if (this.validateForm()) {
        this.form.submit();
      }
    });
  }

  setupPopperPlugin() {
    this.hideOnPopperBlur = {
      name: 'hideOnPopperBlur',
      defaultValue: true,
      fn(instance) {
        return {
          onCreate() {
            instance.popper.addEventListener('focusout', (event) => {
              if (
                instance.props.hideOnPopperBlur
                  && event.relatedTarget
                  && !instance.popper.contains(event.relatedTarget)
              ) {
                instance.hide();
              }
            });
          },
        };
      },
    };
  }

  setupLanguageSwitcher() {
    const languageSwitchers = this.footer.querySelectorAll('.language-switcher');
    if (!languageSwitchers) { return; }
    [...languageSwitchers].forEach((languageSwitcher) => {
      const switcherButton = languageSwitcher.querySelector('.switcher-button');
      const languages = languageSwitcher.querySelector('.languages');
      languages.style.minWidth = `${switcherButton.offsetWidth}px`;
      const languageButtons = languages.querySelectorAll('button');
      [...languageButtons].forEach((button) => {
        button.addEventListener('click', () => {
          window.location.href = button.dataset.url;
        });
      });

      tippy(switcherButton, {
        content: languages,
        offset: [0, 4],
        allowHTML: true,
        trigger: 'click',
        appendTo: 'parent',
        interactive: 'true',
        placement: 'bottom-start',
        plugins: [this.hideOnPopperBlur],

        render(instance) {
          const popper = document.createElement('div');
          popper.appendChild(instance.props.content);
          return { popper };
        },
      });
    });
  }

  /* eslint-disable */
  validateForm() {
    let value = '';
    const email = document.SubscribeForm.SubscriberForm_email;
    value = email.value;
    if (value == null || value == '') {
      var errorElement = document.getElementById('SubscriberForm_email_error_required');
      if (errorElement) {
        errorElement.style.display = 'block';
      }
      email.focus();
      return false;
    }

    var errorElement = document.getElementById('SubscriberForm_email_error_required');
    if (errorElement) {
      errorElement.style.display = 'hidden';
    }

    if (!RegExp(/^(?:[A-Za-z0-9!#$%&\'*+\/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*|""(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*"")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/).test(value)) {
      var errorElement = document.getElementById('SubscriberForm_email_error_0');
      if (errorElement) {
        errorElement.style.display = 'block';
      }
      email.focus();
      return false;
    }

    var errorElement = document.getElementById('SubscriberForm_email_error_0');
    if (errorElement) {
      errorElement.style.display = 'hidden';
    }

    if (!RegExp(/^[^\n\r]{0,400}$/).test(value)) {
      var errorElement = document.getElementById('SubscriberForm_email_error_1');
      if (errorElement) {
        errorElement.style.display = 'block';
      }
      email.focus();
      return false;
    }

    var errorElement = document.getElementById('SubscriberForm_email_error_1');
    if (errorElement) {
      errorElement.style.display = 'hidden';
    }

    const submitButton = document.SubscribeForm.SubscriberForm_SubmitButton;
    submitButton.disabled = true;

    return true;
  }
  /* eslint-enable */
}

domReady(() => {
  Footer.init();
});
